<script setup lang="ts">
import { reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import DetailedJobAttachmentsDropZoneField from '@/components/fields/DetailedJobAttachmentsDropZoneField.vue';
import useForm from '@/composables/useForm';

export interface InitialData {
  attachments?: File[];
}

export interface ValidData {
  attachments: File[];
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [formData: ValidData, cb: () => void];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData, () => {
    formData.attachments = []; // TODO HACK form reset with attachments
  });
});

const attachmentsLimit = 1;
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.spreadsheetAttachmentsSearchForm"
    data-testid="spreadsheetAttachmentsSearchForm"
    @submit.prevent="handleSubmit"
  >
    <DetailedJobAttachmentsDropZoneField
      v-model="formData.attachments"
      :limit="attachmentsLimit"
      :disabled="props.loading"
      :class="$style.field"
      :or-text="'or drop spreadsheet here'"
      :is-hide-limit="true"
    />
    <KBtn
      type="submit"
      size="lg"
      prepend-icon="mdi-download-outline"
      :loading="props.loading"
      :disabled="
        !isValid ||
        !formData.attachments?.length ||
        formData.attachments.length > attachmentsLimit
      "
      :class="$style.submit"
    >
      Upload
    </KBtn>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.spreadsheetAttachmentsSearchForm {
}
  .field {
    display: inline-block;
    vertical-align: top;
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .submit {
    margin-bottom: calc(0.5rem + 22px);
  }
</style>
